import * as React from "react";

const VscContentContext = React.createContext<string|null>(null);

export default VscContentContext;